interface MissionTaskCardViewProps {
  children: React.ReactNode;
}

const MissionTaskCardView: React.FC<MissionTaskCardViewProps> = ({ children }: MissionTaskCardViewProps) => {
  return (
    <div className='fixed inset-0 overflow-hidden sm:px-8 bg-[rgba(17,16,21,0.50)] backdrop-blur-[11.30px] z-50 animate-fade-in'>
      <div className='flex items-center justify-center w-full h-full'>{children}</div>
    </div>
  );
};

export default MissionTaskCardView;
